import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hidden" }
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Checkbox, {
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        inputId: _ctx.item.uuid?.concat(_ctx.item?.keywordRank),
        value: _ctx.item,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelect(_ctx.item)))
      }, null, 8, ["modelValue", "inputId", "value"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`flex items-center gap-3 py-1 px-3 rounded-full transition-all duration-200 cursor-pointer ${
        _ctx.item?.isEval
          ? 'bg-h-primary-700 text-white border'
          : 'bg-white text-h-primary-700 flex-row-reverse border border-h-primary-400'
      } hover:bg-h-secondary-200 hover:text-h-secondary-800 hover:border-h-secondary-900`)
    }, [
      _createElementVNode("label", {
        class: "flex gap-2 items-center cursor-pointer",
        for: _ctx.item.uuid?.concat(_ctx.item?.keywordRank)
      }, [
        _createElementVNode("p", null, _toDisplayString(_ctx.item.keyword), 1),
        _createVNode(_component_v_icon, {
          name: `${_ctx.item?.isEval ? 'fa-regular-times-circle' : 'hi-plus-sm'}`,
          class: "hover:scale-110 transition-all"
        }, null, 8, ["name"])
      ], 8, _hoisted_2)
    ], 2)
  ]))
}